// export default Devis;
import "./index.scss";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../component/authProvider";
import ClientLayout from "../../component/appLayouts/clientLayout/clientLayout";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import InfiniteScroll from "react-infinite-scroll-component";
import AppButton from "../../component/AppButton";
import SelectForm from "../../component/selectForm";
import { showSuccessToaster } from "../../component/toasters/success";
import { showErrorToaster } from "../../component/toasters/error";
import ModalForm from "../../component/modal";
import DevisService from "../../services/devis.service"; // Import service functions
import Loading from "../../component/loading";
import DataTableDisplay from "../../component/ListeDevis/ListeDevis";
import emptyDevis from "../../assets/emtyDevis.png";
import DevisUser from "../../component/devisUser";
import iconAddDevis from "../../assets/add.png";
import { Display } from "react-bootstrap-icons";
import iconSearch from "../../assets/Search.png";
import checkDevise from "../../assets/check.png";
import CreateDevis from "../../component/modalcreateDevis";
import ResponsiveCards from "../../component/ResponsiveCards";

function Devis({ Devis }) {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const userId = currentUser?.userId;
  const firstname = currentUser?.firstname?.split(" ")[0];
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const [hasMore, setHasMore] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [devisList, setDevisList] = useState([]);
  const [devisLists, setDevisLists] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState(""); // Add search query state
  const [visibleDevis, setVisibleDevis] = useState([]); // State to manage visible devis count

  const {
    setValue,
    handleSubmit,
    watch,
    register: formRegister,
    formState: { errors },
  } = useForm({
    defaultValues: {
      userId: userId,
      activitySector: "",
      servicesDemandes: [],
      budgetEstime: "",
      devise: "",
      description: "",
      dateSoumission: "",
      pieceJointe: null,
    },
  });

  // Load data from Devis service
  const loadData = async () => {
    setIsLoading(true);
    try {
      const res = await DevisService.getAllDevis();
      if (res?.data?.data) {
        const transformedData =
          res?.data?.data?.map((item) => ({
            ...item,
            typeTitle: item?.type?.title,
          })) || [];

        const isClient = currentUser?.role === "client";
        const clientData = isClient
          ? transformedData.filter((devis) => devis?.clientId?._id === userId)
          : transformedData;

        setDevisList(clientData);
        setFilteredData(clientData);
        setVisibleDevis(clientData.slice(0, 5)); // Show first 5 devis initially
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }
    setIsLoading(false);
  };

  // Fetch more data when scrolling
  const fetchMoreData = () => {
    if (filteredData.length <= visibleDevis.length) {
      setHasMore(false); // No more data to load
      return;
    }

    const nextItems = filteredData.slice(
      visibleDevis.length,
      visibleDevis.length + 5
    );
    setVisibleDevis((prevItems) => [...prevItems, ...nextItems]); // Add more devis to the list
  };

  const fetchUserDevis = async () => {
    setLoading(true);
    try {
      if (currentUser.Role === "gestionnaire") {
        const res = await DevisService.getAllClientsDevis(); // <-- fetch all devis
        setDevisLists(res);
      } else {
        const res = await DevisService.getDevisByUserId(currentUser.userId); // <-- fetch user's devis
        setDevisLists(res);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Handle search filtering
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query); // Update search query state
    const filtered = devisList.filter(
      (devis) =>
        devis.clientId?.firstname.toLowerCase().includes(query) ||
        devis?.description.toLowerCase().includes(query)
    );
    setFilteredData(filtered);
    setVisibleDevis(filtered.slice(0, 5)); // Reset visible devis to first 5 after filtering
  };

  useEffect(() => {
    fetchUserDevis();
    loadData();
  }, []);

  return (
    <ClientLayout>
      <div id="HomePage" className="home-page">
        <div className="container-fluid">
          <div className="header-section">
            {devisLists.length === 0 && (
              <div className="devis-headder d-flex justify-content-between align-items-center mb-4 p-3">
                <div className="devis-total me-4 fs-5">
                  {t("Devis")} ({devisLists.length})
                </div>
              </div>
            )}

            <div className="d-flex justify-content-between align-items-center">
              <h3 className="title">
                {devisLists?.length > 0
                  ? t("Liste des devis soumis")
                  : t("Bienvenue !")}
              </h3>

              {devisLists.length > 0 && (
                <div className="add-devis-btn">
                  <AppButton
                    onClick={() => {
                      setOpen(true);
                    }}
                  >
                    {`Nouveau devis`}
                    <img
                      src={iconAddDevis}
                      alt="empty devis Logo"
                      className="logo ms-4"
                    />
                  </AppButton>
                </div>
              )}
            </div>

            <div className={devisLists.length === 0 ? "devis-container" : ""}>
              {devisLists.length === 0 ? (
                <div className="empty-data-container text-center p-3">
                  <img
                    src={emptyDevis}
                    alt="empty devis Logo"
                    className="logo "
                    style={{width:"70%"}}
                  />
                  <div className="add-devis-btn d-flex justify-content-center align-items-center">
                    <AppButton
                      onClick={() => {
                        setOpen(true);
                      }}
                    >
                      {`Créer un devis`}
                      <img
                        src={checkDevise}
                        alt="empty devis Logo"
                        className="ms-2"
                      />
                    </AppButton>
                  </div>
                </div>
              ) : (
                <div className="d-flex justify-content-between align-items-center">
                  <div className="devis-list-container">
                    {isMobile > 599 ? (
                      <DevisUser
                        devisList={devisLists}
                        fetchUserDevis={fetchUserDevis}
                      />
                    ) : (
                      <InfiniteScroll
                        dataLength={visibleDevis.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        loader={
                          hasMore && (
                            <div className="d-flex justify-content-center">
                              <Loading />
                            </div>
                          )
                        }
                      >
                        <DevisUser
                          devisList={visibleDevis}
                          fetchUserDevis={fetchUserDevis}
                        />
                      </InfiniteScroll>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {open && (
          <CreateDevis
            fetchUserDevis={fetchUserDevis}
            setOpen={setOpen}
            open={open}
          />
        )}
      </div>
    </ClientLayout>
  );
}

export default Devis;
